<main class="ma__form-page" id="main-content" tabindex="-1">

    <div class="main-content main-content--two container page-container">

        <div >

            <ngx-spinner bdColor="rgba(51, 51, 51, 1.0)" size="default" type="ball-spin-clockwise">  
                <p style="color: white">Please Wait. </p>  
            </ngx-spinner> 
         

                <div class="form-row" style="display: block; margin-top: 1%;">
                    <h4  >Waste Site & Reportable Releases Information</h4>
                </div>
                <div class="col-md-12 form-row">
                    <div class="col-md-4">
                            <div style="background-color:#ccc;padding: 20px; margin-bottom: 20px;">
                            <h4>Related links</h4>
                            <div style="margin-top: 10px;" ng-transclude="links">
                            <div>
                                <a [routerLink]="['/viewer', specififcRTN]">Supporting Documents</a></div>
                            <div><a target="_blank"  href={{lspLookup}}>LSP Lookup</a></div>
                            </div>
                            </div>
                    </div>
                    <div class="col-md-1">
                    </div>
                    <div class="col-md-7">
                    <div class="form-row" *ngFor="let items of formItems;">
                        <ng-container  *ngFor="let item of items">
                            <ng-container *ngIf="item.iterable != true;">
                                <app-control class="{{item.width}}" [property]="item" [form]="searchFields"></app-control>
                            </ng-container>
                        </ng-container>
                    </div>
                </div>

                <div class="col-md-12 form-row">
                    <div class="col-md-5">
                     
                        <div class="form-row" *ngIf="!(responseAction.length==0);">
                            <div >
                                    <strong>Response Action Information</strong>
                            </div>
                        <table class="table  table-bordered table-striped">
                            <thead>
                                <tr>
                                    <th style="cursor: pointer;" *ngFor="let column of responseActionInformationSortableColumns">
                                        {{column.title}}
                                        </th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr  *ngFor="let item of responseAction;">
                                    <td>
                                        {{item.responseActionType}} 
                                    </td>
                                    <td>
                                        {{item.status}} 
                                    </td>
                                    <td>
                                        {{item.submittalDate | date:'MM/dd/YYYY'}} 
                                    </td>
                                    <td>
                                        {{item.raoClass}} 
                                    </td>
                                    <td>
                                        {{item.activityUseLimitationDate | date:'MM/dd/YYYY'}} 
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                        </div>
          
                    </div>
                    <div class="col-md-1"></div>
                    <div class="col-md-6">
                        <div class="form-row" *ngIf="!(chemical.length==0);">
                        <div >
                                <strong>Chemicals</strong>
                        </div>
                        <table class="table  table-bordered table-striped">
                            <thead>
                                <tr>
                                    <th style="cursor: pointer;" *ngFor="let column of chemicalSortableColumns">
                                        {{column.title}}
                                        </th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr  *ngFor="let item of chemical;">
                                    <td>
                                        {{item.chemical}} 
                                    </td>
                                    <td>
                                        {{item.amount}} 
                                    </td>
                                    <td>
                                        {{item.unit}} 
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                        </div>

                        <div class="form-row" *ngIf="!(lsp.length==0);">
                            <div >
                                <strong>LSPs</strong>
                            </div>
                            <table class="table  table-bordered table-striped">
                                <thead>
                                    <tr>
                                        <th style="cursor: pointer;" *ngFor="let column of lspSortableColumns">
                                            {{column.title}}
                                            </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr  *ngFor="let item of lsp;">
                                        <td>
                                            {{item.lsp}} 
                                        </td>
                                        <td>
                                            <a target="_blank"  href={{lspDetail}}{{item.lspNumber}}>{{item.lspNumber}}</a>
                                             
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                            </div>

                                <div class="form-row" *ngIf="!(raoDetail.length==0);">
                                    <div >
                                        <strong>RAO Detail</strong>
                                    </div>
                                    <table class="table  table-bordered table-striped">
                                        <thead>
                                            <tr>
                                                <th style="cursor: pointer;" *ngFor="let column of raoDetailSortableColumns">
                                                    {{column.title}}
                                                    </th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr  *ngFor="let item of raoDetail;">
                                                <td>
                                                    {{item.class}} 
                                                </td>
                                                <td>
                                                    {{item.method}} 
                                                </td>
                                                <td>
                                                    {{item.gwCategory}} 
                                                </td>
                                                <td>
                                                    {{item.soilCategory}} 
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                    </div>

                                    <div class="form-row" *ngIf="!(tier.length==0);">
                                        <div >
                                            <strong>Tier Classification Detail</strong>
                                        </div>
                                        <table class="table  table-bordered table-striped">
                                            <thead>
                                                <tr>
                                                    <th style="cursor: pointer;" *ngFor="let column of tierClassificationDetailsortableColumns">
                                                        {{column.title}}
                                                        </th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr  *ngFor="let item of tier;">
                                                    <td>
                                                        {{item.zone2}} 
                                                    </td>
                                                    <td>
                                                        {{item.imminentHazard}} 
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                        </div>

                                        <div class="form-row" *ngIf="!(secondaryRTN.length==0);">
                                            <div >
                                                <strong>Secondary RTNs</strong>
                                            </div>
                                            <table class="table  table-bordered table-striped">
                                                <thead>
                                                    <tr>
                                                        <th style="cursor: pointer;" *ngFor="let column of secondaryRTNSortableColumns">
                                                            {{column.title}}
                                                            </th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr  *ngFor="let item of secondaryRTN;">
                                                        <td>
                                                            <a target="_blank" [routerLink]="['/detailviewer', item.secondaryRTN]" >
                                                                {{item.secondaryRTN}} 
                                                             </a>
                                                            
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                            </div>

                                            <div class="form-row" *ngIf="!(relatedRTN.length==0);">
                                                <div >
                                                    <strong>Related RTNs</strong>
                                                </div>
                                                <table class="table  table-bordered table-striped">
                                                    <thead>
                                                        <tr>
                                                            <th style="cursor: pointer;" *ngFor="let column of relatedRTNSortableColumns">
                                                                {{column.title}}
                                                                </th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        <tr  *ngFor="let item of relatedRTN;">
                                                            <td>
                                                                {{item.primaryRTN}} 
                                                            </td>
                                                            <td>
                                                                <a target="_blank" [routerLink]="['/detailviewer', item.secondaryRTN]" >
                                                                    {{item.secondaryRTN}} 
                                                                 </a>
                                                            </td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                                </div>
                    </div>
                </div>

                <div class="col-md-12 form-row">
                    <div class="col-md-1"></div>
                    <div class="col-md-10">
                    <ng-container *ngIf="plotingMapData.length>0">
                        <div style="text-align:center">
                            <span>Location</span>
                        </div>
                    
                    <app-esri-map [center]="mapCenter" [basemap]="basemapType" [zoom]="mapZoomLevel" [plotingData]="plotingMapData" (mapLoaded)="mapLoadedEvent($event)">
                    </app-esri-map>
                    <br>
                    <img class="center" src="./assets/img/map_legend2.png">
                     </ng-container>
                    </div>
                   <div class="col-md-1"></div>
                </div>

        </div>
        
        <br>
        <div class="generic-button-group">
            <div>
                <div class="generic-button-group-left">
                    <button class="btn btn-default btn-custom" (click)="back()"><i class="fa fa-chevron-left"></i>&nbsp;Previous</button>
                    <!-- <button class="btn btn-primary btn-custom float-right" [routerLink]="['']"><i class="fa fa-search"></i>&nbsp;Search Again</button> -->
                    <button class="btn btn-primary float-right" style="margin-top:20px;" [routerLink]="['']" type="submit" value="submit search"><svg aria-hidden="true" focusable="false" data-prefix="fas" data-icon="search" class="svg-inline--fa fa-search fa-w-16" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path style="fill:currentColor;" d="M505 442.7L405.3 343c-4.5-4.5-10.6-7-17-7H372c27.6-35.3 44-79.7 44-128C416 93.1 322.9 0 208 0S0 93.1 0 208s93.1 208 208 208c48.3 0 92.7-16.4 128-44v16.3c0 6.4 2.5 12.5 7 17l99.7 99.7c9.4 9.4 24.6 9.4 33.9 0l28.3-28.3c9.4-9.4 9.4-24.6.1-34zM208 336c-70.7 0-128-57.2-128-128 0-70.7 57.2-128 128-128 70.7 0 128 57.2 128 128 0 70.7-57.2 128-128 128z"></path></svg>&nbsp;Search Again</button>
                </div>
                <br />
                <br />
            </div>
        </div>
        <br>
        <div class="float-right">
            <span>Please contact <a href="mailto:BWSC.eDEP@mass.gov">BWSC.eDEP@mass.gov</a> with questions.   </span><br>
            <span class="float-right">Data is updated once a day</span>
          </div>
     
        
    </div>
    <!-- <app-scroll-to-top></app-scroll-to-top> -->
</div>
</main>

